import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-59eddc9a")

_pushScopeId("data-v-59eddc9a")
const _hoisted_1 = { class: "reportConfirm_reportItem" }
const _hoisted_2 = { class: "reportConfirm_reportItem_show" }
const _hoisted_3 = { class: "filedName" }
const _hoisted_4 = { class: "filedValue" }
const _hoisted_5 = { class: "reportConfirm_reportItem_box reportConfirm_reportItem_hide" }
const _hoisted_6 = { class: "reportConfirm_reportItem_detect" }
const _hoisted_7 = { class: "reportConfirm_reportItem_detectNum" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("故障 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_reportComfirmTitle = _resolveComponent("reportComfirmTitle")
  const _component_van_icon = _resolveComponent("van-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_reportComfirmTitle, {
      titleTxt: "配置及故障项",
      isShowRight: true,
      goPageType: "peizhiguzhang"
    }),
    _withDirectives(_createVNode("ul", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.renderData.checkItemVOList, (item) => {
        return (_openBlock(), _createBlock("li", {
          class: "reportConfirm_reportItem_show_item",
          key: item.itemCode
        }, [
          _createVNode("span", _hoisted_3, _toDisplayString(item.itemName), 1),
          _createVNode("b", _hoisted_4, [
            _createTextVNode(_toDisplayString(item.itemDesc) + " ", 1),
            _createVNode("span", null, _toDisplayString(item.tip), 1)
          ])
        ]))
      }), 128))
    ], 512), [
      [_vShow, _ctx.state.isShowMore]
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("span", _hoisted_6, [
        _createVNode("b", _hoisted_7, _toDisplayString(_ctx.renderData.itemCount), 1),
        _hoisted_8
      ]),
      _createVNode("span", {
        class: "reportConfirm_lookMore",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showOrHide && _ctx.showOrHide(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.state.isShowMore ? '收起' : '展开') + " ", 1),
        _withDirectives(_createVNode(_component_van_icon, { name: "arrow-down" }, null, 512), [
          [_vShow, !_ctx.state.isShowMore]
        ]),
        _withDirectives(_createVNode(_component_van_icon, { name: "arrow-up" }, null, 512), [
          [_vShow, _ctx.state.isShowMore]
        ])
      ])
    ])
  ]))
})